import { useIntl } from 'react-intl'

import { useAuth } from '@/shared/auth/auth-context'

/**
 * A permanent, undismissible banner in `disabled` mode, so a local run is never mistaken for a
 * real sign-in. Renders nothing in `b2c` mode.
 */
export function AuthDisabledBanner() {
  const intl = useIntl()
  const { mode } = useAuth()

  if (mode !== 'disabled') {
    return null
  }

  // <output> carries role="status" semantics without ARIA.
  return (
    <output className="block bg-critical px-3 py-2 text-center text-sm font-semibold text-accent-foreground sm:px-6">
      {intl.formatMessage({ id: 'shell.authDisabled' })}
    </output>
  )
}
